export const formatChartDate = (dateStr, endDate = null) => {
    const [day, month] = dateStr.split('-');
    const dayNum = parseInt(day);
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    // Helper function to get ordinal suffix
    const getOrdinalSuffix = (num) => {
        const j = num % 10;
        const k = num % 100;
        if (j === 1 && k !== 11) return 'st';
        if (j === 2 && k !== 12) return 'nd';
        if (j === 3 && k !== 13) return 'rd';
        return 'th';
    };
    
    if (endDate) {
        const [endDay] = endDate.split('-');
        const endDayNum = parseInt(endDay);
        if (dayNum === endDayNum) {
            return `${dayNum}${getOrdinalSuffix(dayNum)} ${monthNames[parseInt(month) - 1]}`;
        }
        return `${dayNum}${getOrdinalSuffix(dayNum)}-${endDayNum}${getOrdinalSuffix(endDayNum)} ${monthNames[parseInt(month) - 1]}`;
    }
    
    return `${dayNum}${getOrdinalSuffix(dayNum)} ${monthNames[parseInt(month) - 1]}`;
};

export const calculateYAxisConfig = (values, options = {}) => {
    const { padding = 10 } = options;
    const maxValue = Math.max(...values);
    const paddingAmount = maxValue * (padding / 100);
    let yAxisMax = maxValue + paddingAmount;
    const magnitude = Math.pow(10, Math.floor(Math.log10(yAxisMax)));
    const normalizedMax = yAxisMax / magnitude;
    let niceMax;
    if (normalizedMax <= 1) niceMax = 1;
    else if (normalizedMax <= 2) niceMax = 2;
    else if (normalizedMax <= 2.5) niceMax = 2.5;
    else if (normalizedMax <= 5) niceMax = 5;
    else niceMax = 10;
    yAxisMax = niceMax * magnitude;
    const numIntervals = 5;
    const stepSize = yAxisMax / numIntervals;

    return {
        max: yAxisMax,
        stepSize,
        ticks: {
            stepSize,
            callback: (value) => {
                if (value >= 1000) {
                    return `${value / 1000}k`;
                }
                return value;
            }
        }
    };
};

export const createChartGradient = (ctx, colorStart, colorEnd, height = 300) => {
    const gradient = ctx.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, colorStart);
    gradient.addColorStop(1, colorEnd);
    return gradient;
}; 